import React, { Component } from 'react';
import { Form, FormGroup } from 'reactstrap';
import SchedulingCard from 'shared/components/Cards/scheduling_card';
import '../../../web/index.css'
import * as FontAwesome from 'react-icons/lib/fa';

export default class StatusView extends Component {
    render() {
        var user_data = [{ id: "1", name: "FS" }, { id: "2", name: "AL" },{ id: "3", name: "BL" }];
        return (
                <div className="row row-padding">
                        <div className="col-md-4 col-sm-6 content-center" > 
                            <div className="cHeader">
                                Completed 
                               
                            </div>
                            {/* <SchedulingCard status_code={"completed"} is_charged={true} toggle={this.props.toggle} periodical_name={"Vacate room cleaning"} freq={"V"} date={"29 Jan"} users={user_data}/>
                            <SchedulingCard status_code={"completed"} is_charged={false} toggle={this.props.toggle} periodical_name={"Window cleaning"} freq={"W"} date={"1 Jan"} users={user_data}/>
                            <SchedulingCard status_code={"completed"} is_charged={true} toggle={this.props.toggle} periodical_name={"Floor scrubbing"} freq={"F"} date={"12 Jan"} users={user_data}/> */}
                        </div>
                        <div className="col-md-4 col-sm-6 content-center" >
                        <div className="cHeader">
                                Due
                                
                            </div>
                            {/* <SchedulingCard status_code={"unassigned"} toggle={this.props.toggle} periodical_name={"Vacate room cleaning"} freq={"V"} date={"29 Jan"} users={user_data}/>
                            <SchedulingCard status_code={"abandoned"} is_charged={true} toggle={this.props.toggle} periodical_name={"Window cleaning"} freq={"W"} date={"1 Jan"} users={user_data}/>
                            <SchedulingCard status_code={"unassigned"} is_charged={false} toggle={this.props.toggle} periodical_name={"Floor scrubbing"} freq={"F"} date={"12 Jan"} users={user_data}/>
                            <SchedulingCard status_code={"assigned"} is_charged={true} toggle={this.props.toggle} periodical_name={"Floor scrubbing"} freq={"F"} date={"12 Jan"} users={user_data}/> */}
                        </div>
                        <div className="col-md-4 col-sm-6 content-center" >
                        <div className="cHeader">
                                 Upcomming 
                               
                            </div>
                            {/* <SchedulingCard status_code={"assigned"} is_charged={true} toggle={this.props.toggle} periodical_name={"Vacate room cleaning"} freq={"V"} date={"29 Jan"} users={user_data}/>
                            <SchedulingCard status_code={"assigned"} is_charged={false} toggle={this.props.toggle} periodical_name={"Window cleaning"} freq={"W"} date={"1 Jan"} users={user_data}/>
                            <SchedulingCard status_code={"assigned"} is_charged={true} toggle={this.props.toggle} periodical_name={"Floor scrubbing"} freq={"F"} date={"12 Jan"} users={user_data}/> */}
                        </div>
                </div>
            )
        }
}


// WEBPACK FOOTER //
// ./src/shared/containers/PeriodicalStatus/status_view.js